import React from 'react'
import { Spacing, Row, Column, Button } from 'quantic'

function FooterUI() {
  return (
    <Row>
      <Spacing size="sm" />
      <Column size={12}>
        <Button onClick={() => null} fullWidth info>
          Obter ajuda
        </Button>
      </Column>
    </Row>
  )
}

export default FooterUI
